<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="供应商" prop="supplierId">
              <a-select v-model="form.supplierId" placeholder="请选择供应商" show-search :filter-option="filterOption" allow-clear>
                <a-select-option v-for="item in supplierList" :key="item.id" :value="item.id">
                  {{ item.supplierName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="退货原因" prop="returnReason">
              <a-select v-model="form.returnReason" placeholder="请选择退货原因">
                <a-select-option :value="1">质量问题</a-select-option>
                <a-select-option :value="2">错发漏发</a-select-option>
                <a-select-option :value="3">滞销退货</a-select-option>
                <a-select-option :value="4">其他</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-form-model-item label="退货原因描述" prop="returnReasonDesc">
          <a-textarea v-model="form.returnReasonDesc" placeholder="请输入退货原因描述" :rows="2" :maxlength="200" />
        </a-form-model-item>

        <a-form-model-item label="备注">
          <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="2" :maxlength="500" />
        </a-form-model-item>

        <a-divider orientation="left">退货明细</a-divider>

        <a-form-model-item label="添加商品">
          <a-button type="primary" @click="handleSelectGoods">
            <a-icon type="plus" />添加商品
          </a-button>
        </a-form-model-item>

        <a-table
          :columns="itemColumns"
          :data-source="form.items"
          :pagination="false"
          rowKey="key"
          size="middle"
        >
          <span slot="goodsName" slot-scope="text, record">
            {{ text }} <a-tag v-if="record.skuName" color="orange">{{ record.skuName }}</a-tag>
          </span>
          <template slot="returnCount" slot-scope="text, record, index">
            <a-input-number
              v-model="record.returnCount"
              :min="1"
              :max="record.currentStock"
              style="width: 100%"
              size="small"
            />
          </template>
          <template slot="returnReasonDetail" slot-scope="text, record">
            <a-input
              v-model="record.returnReasonDetail"
              placeholder="请输入"
              :max-length="100"
              size="small"
            />
          </template>
          <template slot="remark" slot-scope="text, record">
            <a-input
              v-model="record.remark"
              placeholder="请输入"
              :max-length="100"
              size="small"
            />
          </template>
          <template slot="action" slot-scope="text, record, index">
            <a @click="handleDeleteItem(index)" style="color: red">
              <a-icon type="delete" />删除
            </a>
          </template>
        </a-table>
      </a-form-model>

      <!-- 商品选择弹窗 -->
      <inventory-select ref="inventorySelect" @ok="handleGoodsSelect" />
    </a-spin>
  </a-modal>
</template>

<script>
import { createReturnOrder } from '@/api/retail/inventory'
import { listSupplier } from '@/api/retail/supplier'
import InventorySelect from '../../inventory/modules/InventorySelect'

export default {
  name: 'ReturnForm',
  components: {
    InventorySelect
  },
  data() {
    return {
      title: '',
      visible: false,
      confirmLoading: false,
      supplierList: [],
      form: {
        supplierId: undefined,
        returnReason: undefined,
        returnReasonDesc: undefined,
        remark: undefined,
        items: []
      },
      rules: {
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        returnReason: [{ required: true, message: '请选择退货原因', trigger: 'change' }]
      },
      itemColumns: [
        {
          title: '商品信息',
          dataIndex: 'goodsName',
          key: 'goodsName',
          scopedSlots: { customRender: 'goodsName' },
          ellipsis: true
        },
        {
          title: '当前库存',
          dataIndex: 'currentStock',
          key: 'currentStock',
          width: 100,
          align: 'center'
        },
        {
          title: '退货数量',
          dataIndex: 'returnCount',
          key: 'returnCount',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'returnCount' }
        },
        // {
        //   title: '退货原因明细',
        //   dataIndex: 'returnReasonDetail',
        //   key: 'returnReasonDetail',
        //   width: 150,
        //   scopedSlots: { customRender: 'returnReasonDetail' }
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   key: 'remark',
        //   width: 150,
        //   scopedSlots: { customRender: 'remark' }
        // },
        {
          title: '操作',
          key: 'action',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.getSupplierList()
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getSupplierList() {
      listSupplier().then(response => {
        if (response.data) {
          this.supplierList = response.data || []
        } else if (Array.isArray(response)) {
          this.supplierList = response
        }
      })
    },
    handleAdd() {
      this.title = '采购退货'
      this.visible = true
      this.form = {
        supplierId: undefined,
        returnReason: undefined,
        returnReasonDesc: undefined,
        remark: undefined,
        items: []
      }
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.items.length === 0) {
            this.$message.warning('请至少添加一个退货商品')
            return
          }

          // 校验退货数量
          for (const item of this.form.items) {
            if (!item.returnCount || item.returnCount <= 0) {
              this.$message.warning(`商品【${item.goodsName}】的退货数量必须大于0`)
              return
            }
            if (item.returnCount > item.currentStock) {
              this.$message.warning(`商品【${item.goodsName}】的退货数量(${item.returnCount})不能超过当前库存(${item.currentStock})`)
              return
            }
          }

          this.confirmLoading = true
          createReturnOrder(this.form).then(() => {
            this.$message.success('退货申请已提交，等待审核')
            this.visible = false
            this.$emit('ok')
          }).catch(error => {
            this.$message.error('提交失败：' + (error.message || '未知错误'))
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleSelectGoods() {
      if (!this.form.supplierId) {
        this.$message.warning('请先选择供应商')
        return
      }
      this.$refs.inventorySelect.show(this.form.supplierId)
    },
    handleGoodsSelect(selectedGoods) {
      // 检查是否已存在
      const exists = this.form.items.find(item => item.goodsId === selectedGoods.goodsId && item.skuId === selectedGoods.skuId)
      if (exists) {
        this.$message.warning('该商品已添加')
        return
      }

      this.form.items.push({
        key: Date.now() + Math.random(),
        goodsId: selectedGoods.goodsId,
        skuId: selectedGoods.skuId,
        goodsName: selectedGoods.goodsName,
        skuName: selectedGoods.skuName,
        currentStock: selectedGoods.stock,
        returnCount: 1,
        returnReasonDetail: undefined,
        remark: undefined
      })
    },
    handleDeleteItem(index) {
      this.form.items.splice(index, 1)
    }
  }
}
</script>
